import { Component, Input, OnInit } from '@angular/core';
import { Global } from 'src/app/shared/global';

@Component({
  selector: 'app-guide-container',
  templateUrl: './guide-container.component.html',
  styleUrls: ['./guide-container.component.scss']
})
export class GuideContainerComponent implements OnInit {
  @Input() source = '';
 bubbleText: string;
 categories: string ='';
 cateogoryNumber: string;

  constructor(public global: Global) { 
    
  }

  ngOnInit(): void {
    console.log('here i am');
    this.insertTextToBubbleText();
  
  }

  insertTextToBubbleText() {
    if (this.source == 'userForm') {
      this.bubbleText = "Hi, I’m <b>Sam</b>, I’ll be your guide as you explore each lesson. Before we get going, please answer these   questions to help me personalize your journey."
    } else if (this.source == 'lessonCategories') {
      //this.assignDynamicTxtListToBubbleText();
      //this.bubbleText = 'Great, '+ this.global.userName + '! all of the lessions you can explore today into one of these ' + this.cateogoryNumber +' categories.<br/>' + this.categories + 'What topic do you want to check out first?'
      this.bubbleText = this.global.getEduLessonObj[this.global.selectedEduCategory].guideMessage; 
    } else if (this.source == 'medicare') {
      this.bubbleText = this.global.getEduLessonObj[this.global.selectedEduCategory].lessons[this.global.selectedEduCatLesson].guideMessage;      
    }
  }
  
  assignDynamicTxtListToBubbleText() {
    let categoryNumber = 0;
    this.categories = '<ul>';
    this.global.getEduLessonObj.forEach(element => {
      console.log('element.title', element.title);
      categoryNumber += 1;
      this.categories = this.categories +'<li><b>' + element.title + '</b></li>' ;

    });
    this.categories = this.categories + '</ul>';
    console.log('this.categories', this.categories);
    this.cateogoryNumber = this.global.numberToWords(categoryNumber)
  }
}
